export default "__VITE_ASSET__CUqGLhXr__"